module.exports = __webpack_public_path__ + "img/voting-like-dude.9bd8ae05.svg";